import { render } from "./InstructionsForm.vue?vue&type=template&id=02d25c38&scoped=true"
import script from "./InstructionsForm.vue?vue&type=script&lang=js"
export * from "./InstructionsForm.vue?vue&type=script&lang=js"

import "./InstructionsForm.vue?vue&type=style&index=0&id=02d25c38&lang=css"
import "./InstructionsForm.vue?vue&type=style&index=1&id=02d25c38&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02d25c38"]])

export default __exports__